/* istanbul ignore file */

import { getPadrao } from 'services/api';
import { duckDadosHistorico } from 'store/ducks/formulario';
import { fetchStatusModal } from 'store/fetchActions/fetchApp';
import { ENUM_MODAL } from 'utils/consts';

export const fetchObterHistoricoPorId = formularioId => dispatch => {
  const sucesso = retorno => {
    dispatch(duckDadosHistorico(retorno));
    dispatch(fetchStatusModal(true, ENUM_MODAL.HISTORICO));
  };
  dispatch(getPadrao(`Historico/GetByformularioId/${formularioId}`, sucesso));
};
